import React, { Component, ReactNode } from 'react';
import classnames from 'classnames';
import { WithStyles, withStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import { StringNullableChain } from 'lodash';

// Contexts
import { withTranslate } from '../../../core/TenantProvider';
// Components - Atoms, Organisms,Containers
import APHeading from './../APHeading';
import APSelectMultiLevelDropdown from '../APMultilevelDropdown';
// Files in the same folder
import APSectionStyles from './styles/APSection.style';
// Utils
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { GoogleAnalytics4Tags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';

interface APSectionProps extends WithStyles<typeof APSectionStyles> {
  children: any,
  className?: string,
  sectionHeaderClassName?: string,
  padded: boolean,
  shadow: boolean,
  title?: string,
  subTitle?: string,
  gaTagParam?: string,
  ga4TagParam?: string,
  ga4TagModule?: string,
  link?: string,
  linkText?: ReactNode,
  dropdownData?: any,
  initialDropdownValue?: any,
  onDropdownChange?: any,
  translate: Function
}

class APSection extends Component<APSectionProps, {}> {
  public static defaultProps = {
    padded: true,
    shadow: true
  };

  render() {
    const {
      classes,
      className,
      sectionHeaderClassName,
      children,
      padded,
      shadow,
      title,
      subTitle,
      gaTagParam,
      ga4TagParam,
      ga4TagModule,
      link,
      linkText,
      dropdownData = null,
      initialDropdownValue,
      onDropdownChange,
      translate
    } = this.props;

    const sectionContentCls: string = classnames(className, classes.sectionContent, {
      [classes.sectionContentPadded]: padded,
      [classes.sectionContentShadow]: shadow
    });

    const sectionHeaderTitleCls: string = classnames(classes.sectionHeader, sectionHeaderClassName, {
      [classes.sectionHeaderWithSubHeader]: subTitle
    });

    return (
      <div className={classes.sectionContainer}>
        {title && (
          <APHeading className={sectionHeaderTitleCls} variant="h4">
            {title}
          </APHeading>
        )}
        {subTitle && (
          <APHeading className={classes.sectionSubHeader} variant="body1">
            {subTitle}
          </APHeading>
        )}
        {link && (
          <Link to={link}
            className={classes.link}
            onClick={() => {
              gaTagParam &&
                TriggerGoogleAnalyticsTag(
                  GoogleAnalyticTags.eventAction.click,
                  gaTagParam
                );
              ga4TagParam &&
                TriggerGoogleAnalytics4Tag(
                  ga4TagModule,
                  GoogleAnalytics4Tags.eventAction.click,
                  ga4TagParam
                );
            }
            }
          >
            {linkText}
          </Link>
        )
        }

        {dropdownData && dropdownData.length > 0 && (
          <div className={classes.dropdownWrapper}>
            <APSelectMultiLevelDropdown
              value={initialDropdownValue}
              onChange={onDropdownChange}
              label={translate('commissions.partner.group.dropdown.label')}
              data={dropdownData}
              name={'Partner Group'}
            />
          </div>
        )}

        <div className={sectionContentCls}>
          {children}
        </div>
      </div>
    )
  }
}

export default withTranslate(
  withStyles(APSectionStyles)(APSection)
);
